/**
 * `getSource` / `getLayer` leen `map.style`. Si el mapa se destruyó (desmontar
 * la página, hot reload) o el estilo se está recreando, esa propiedad no está y
 * MapLibre tira `Cannot read properties of undefined`.
 *
 * Todo lo que vuelve después de un `await` (firma de PMTiles, fetch del índice)
 * o de un evento del mapa tiene que preguntar esto antes de tocar el estilo.
 *
 * @param {import('maplibre-gl').Map|null|undefined} map
 * @returns {boolean}
 */
export function canAccessMapStyle(map) {
  return Boolean(map?.style);
}

/**
 * El mapa sigue vivo: no se llamó `remove()` y tiene estilo. Usar después de
 * cualquier `await` antes de tocar el mapa.
 * @param {import('maplibre-gl').Map|null|undefined} map
 * @returns {boolean}
 */
export function isMapAlive(map) {
  return Boolean(map && map._removed !== true && map.style);
}
